import clsx from 'clsx';
import { Control, Controller, FieldError } from 'react-hook-form';

import { Input } from '@/components/Input';
import { formatDurationRussian } from '@/utils/formatDurationRussian';
import { evaluateTimeExpression, parseTimeExpression } from '@/utils/parseTimeInput';

import s from './DurationInput.module.scss';

type DurationInputProps = {
  control: Control<any>;
  name: string;
  error?: FieldError;
  autoFocus?: boolean;
  placeholder?: string;
  required?: boolean;
};

const DurationInput: React.FC<DurationInputProps> = ({
  control,
  name,
  error,
  autoFocus = false,
  placeholder = 'Введите время',
  required = false,
}) => {
  return (
    <Controller
      control={control}
      name={name}
      rules={required ? { required: 'Введите время' } : undefined}
      render={({ field }) => {
        const parsedDuration = field.value ? parseTimeExpression(field.value) : null;
        const isParsed = Boolean(parsedDuration);
        const hasValue = !!field.value?.trim();
        const isNotPositive = hasValue && !isParsed && evaluateTimeExpression(field.value) !== null;
        const invalidMessage = isNotPositive
          ? 'Итог должен быть больше нуля'
          : 'Неверный формат времени';

        return (
          <>
            <Input
              {...field}
              autoFocus={autoFocus}
              autoComplete="off"
              placeholder={placeholder}
              error={!!error || (!isParsed && hasValue)}
              helperText={error?.message || (!isParsed && hasValue ? invalidMessage : '')}
            />
            <div
              className={clsx(s.duration_check, {
                [s.correct]: isParsed,
                [s.incorrect]: !isParsed,
              })}
            >
              <span>
                {field.value ? (isParsed ? formatDurationRussian(parsedDuration!) : '0ч') : '0ч'}
              </span>
            </div>
          </>
        );
      }}
    />
  );
};

export default DurationInput;
